// Pure verdict-tier classification — no React/RN deps, so it's unit-testable
// and reusable. Three tiers under the boolean-inclusion aggregator (docs/22):
// `flagged` when the case clears the inclusion gate; otherwise distinguish
// "we actively saw evidence pointing at the current band" (`confident-ok`,
// ≥1 block looked at) from "we couldn't gather strong enough evidence at all"
// (`thin`, silent across the board). totalScore can be 1-3 when blocks fired
// but none cleared their inclusion gate — that's still "thin" because it's
// not a Proposal-grade story.
const VERDICT_CONFIDENT_TOTAL_SCORE = 1

export type VerdictTier = 'flagged' | 'confident-ok' | 'thin'

export const verdictTier = (
  flagged: boolean,
  totalScore: number | undefined,
  confidence: number,
): VerdictTier => {
  if (flagged) return 'flagged'
  if (totalScore == null) return confidence >= 0.4 ? 'confident-ok' : 'thin'
  return totalScore >= VERDICT_CONFIDENT_TOTAL_SCORE ? 'confident-ok' : 'thin'
}
